import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import ja from "./locales/ja.json";

const LANGUAGE_STORAGE_KEY = "aw-language";
const RESOURCES = {
  en: { root: en },
  es: { root: es },
  fr: { root: fr },
  ja: { root: ja },
} as const;

export const SUPPORTED_LANGUAGE_CODES = new Set(Object.keys(RESOURCES));

function getInitialLanguage() {
  if (typeof window === "undefined") return "en";

  const cachedLanguage = window.localStorage?.getItem(LANGUAGE_STORAGE_KEY);
  return cachedLanguage && SUPPORTED_LANGUAGE_CODES.has(cachedLanguage)
    ? cachedLanguage
    : "en";
}

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  resources: RESOURCES,
  fallbackLng: "en",
  ns: ["root"],
  defaultNS: "root",
  nsSeparator: false,
  keySeparator: ".",
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language;
}

i18n.on("languageChanged", (language: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
  if (typeof window !== "undefined" && SUPPORTED_LANGUAGE_CODES.has(language)) {
    window.localStorage?.setItem(LANGUAGE_STORAGE_KEY, language);
  }
});

export default i18n;
